<template>
    <div class="time-area-container">
        <div class="time-area-date" v-if="showDate">
            <div class="time-area-year global-center">{{ $tools.getDate(data.start_time,"yyyy") }}</div>
            <div class="time-area-day global-center">{{ $tools.getDate(data.start_time,"MM-dd")}}</div>
        </div>
        <div class="time-info">
            <div class="time-point-group">
                <div class="time-point-block time-area-block">
                    <div class="time-ponit"></div>
                </div>
                <div class="time-point-line time-info-block"></div>
                <div class="time-point-block time-area-block">
                    <div class="time-ponit"></div>
                </div>
            </div>
            <div class="time-number-group">
                <div class="time-number time-area-block">{{ $tools.getDate(data.start_time,"hh:mm")}}</div>
                <div class="time-info-block time-number-block"></div>
                <div class="time-number time-area-block">{{ $tools.getDate(data.end_time,"hh:mm")}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "timeArea",
    props:{
        data:{
            type:Object,
            default:()=>{
                return {}
            }
        },
        showDate:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
        }
    },
    methods: {
    },

}
</script>

<style scoped>
.time-area-container {
    display: flex;
    flex-direction: column;
    font-size:13px;
    padding:0 11px;
}
.time-area-date{
    display: flex;
    flex-direction: column;
    width: 50px;
    height: 41px;
    border-radius: 3px;
    border: 1px solid var(--el-color-primary);
    background:#fff;
    font-weight: Bold;
    margin-bottom:14px;
}
.time-area-date div{
    flex:1 0 0;
}
.time-area-year{
    background: var(--el-color-primary);
    border-radius: 3px;
    color:#fff;
    background: var(--el-color-primary);
}
.time-info{
    display: flex;
}
.time-point-group{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.time-ponit{
    width: 6px;
    height: 6px;
    background: var(--el-color-primary);
    border-radius: 50%;
    /* 记得改颜色 */
    box-shadow: 0 0px 1px 2px  #ca1e8e33; 
}
.time-point-block {
    width:6px;
}
.time-point-line{
    width: 1px;
    background:#C9C9C9;
    /* margin:3px 0; */
}
.time-info-block{
    height: 12px;
}
.time-number-block{
    visibility: hidden;
}
.time-area-block{
    height:18px;
    line-height: 18px;
    display: flex;
    align-items: center;
    font-size:13px;
}
.time-number-group{
    margin-left:9px;
}
</style>
